module.exports = __webpack_public_path__ + "img/arrow-bottom.1d416499.svg";